export enum ClientCommerceId {
  'Argentina' = 1,
  'COMEX' = 2,
}
